<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col"> <label class="Label1 spacing-label">
                    <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;"
                        (click)="ViewProfile()">
                        <div class="col-2">
                            <img *ngIf="ProfileLoad[0].Photo != null && ProfileLoad[0].Photo!= ''" mat-card-image
                                class="userImage" [src]="ProfileLoad[0].Photo" />
                            <div *ngIf="ProfileLoad[0].Photo == null || ProfileLoad[0].Photo == ''"
                                class="initial-image">
                                <div class="image">
                                    {{common.getInitial(ProfileLoad[0].FullName)}}
                                </div>
                            </div>
                        </div>
                        <div class="col-9 userdetail">
                            <span class="text-label">{{ProfileLoad[0].FullName}}</span><br />
                            <span class="text-label-light">#{{ProfileLoad[0].EmpCode}}</span><br />
                            <span class="text-label-light">{{ProfileLoad[0].DesignationName}}</span>
                        </div>
                    </div>
                </label></div>
            <div class="col-auto">
                <!-- <span class="btn-primary cursor-pointer" *ngIf="!isDisabled"
                    [routerLink]="['/ReporteeAttendance/']">Attendance</span>
                <span *ngIf="isDisabled">Loading...</span> -->
                <br>
                <button class="btn btn-sm btn-primary" name="excel" *ngIf="ProfileID != this.user.UserId"
                    (click)="MyTeams('Reportees', this.user.UserId);MyTeams('Profile', this.user.UserId)">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Back':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body" style="overflow: auto;">
        <div class="row">
            <div class="col-md-3 p-1">
                <input type="text" class="form-control form-control-sm" placeholder="search..." name="searching"
                    [(ngModel)]="Search" (input)="SearchData()" style="border: 2px solid rgb(121, 118, 118);">
            </div>
            <div class="col p-0">
                <!-- <button class="btn btn-sm btn-primary" name="search" (click)="SearchData()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button> -->
            </div>
            <div class="col-auto">
                <button class="btn btn-sm" name="attendance" style="border: none;color: #0078D4; font-weight: 600;"
                    (click)="ViewAttendance()">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Attendance':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 p-1" *ngFor="let element of RepoteesLoad; let i = index" style="margin-bottom:1%;">
                <div class="card shadow" style="height: 110%;">
                    <div class="row" style="margin: 1px;">
                        <div class="col-md-10"
                            (click)="MyTeams('Reportees',element['EmpMasterID']);MyTeams('Profile',element['EmpMasterID']);">
                            <label class="Label1 spacing-label">
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="element['Photo']!= null && element['Photo']!= ''" mat-card-image
                                            class="userImage" [src]="element['Photo']" />
                                        <div *ngIf="element['Photo'] == null || element['Photo'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(element['FullName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail" style="margin:2%;">
                                        <span class="text-label"
                                            style="margin-bottom:1%;">{{element['FullName']}}</span><br />
                                        <span class="text-label-light"
                                            style="margin-bottom:1%;">#{{element['EmpCode']}}</span><br />
                                        <span class="text-label-light">{{element['DesignationName']}}</span>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-sm" name="att{{i}}" (click)="AttendanceView(element)">
                                <img *ngIf="!isDisabled" src="../../../assets/AttendanceCal.png" alt="Attendance"
                                    style="height: 25px; width: 25px;" />
                                <span class="spinne r-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>